import { Pipe, PipeTransform } from '@angular/core';

import { computeDiffTime, convertTimeToDate } from '@shared/utils';

@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  transform(start: string, finish: string): string {
    return computeDiffTime(convertTimeToDate(finish), convertTimeToDate(start));
  }
}
